import externalPlayers from '../../data/reference/inazuma_catalog/players.json';
import baseTechniques from '../../data/techniques/techniques.json';
import externalTechniques from '../../data/reference/inazuma_catalog/techniques.json';
import formationsData from '../../data/formations/formations.json';
import teamsData from '../../data/teams/teams.json';
import tokensData from '../../data/recruitment/tokens.json';
import poolsData from '../../data/reference/inazuma_catalog/pools.json';
import externalTeams from '../../data/reference/inazuma_eleven_api/teams.json';
import type { Formation, Player, Team, Technique } from './types';

export const players = (externalPlayers.players as Player[]).map((player) => ({
  ...player,
  techniques: player.techniques.length ? player.techniques : (player.available_techniques ?? []).slice(0, 2),
}));
export const techniques = [
  ...(baseTechniques.techniques as Technique[]),
  ...(externalTechniques.techniques as Technique[]),
];
export const formations = formationsData.formations as unknown as Formation[];
export const starterPlayerIds = [
  'inazuma_eleven_api_reference_1',
  'inazuma_eleven_api_reference_3', 'inazuma_eleven_api_reference_4', 'inazuma_eleven_api_reference_6',
  'inazuma_eleven_api_reference_11', 'inazuma_eleven_api_reference_14', 'inazuma_eleven_api_reference_1034',
  'inazuma_eleven_api_reference_7', 'inazuma_eleven_api_reference_9', 'inazuma_eleven_api_reference_10',
  'inazuma_eleven_api_reference_13', 'inazuma_eleven_api_reference_4052', 'inazuma_eleven_api_reference_4053',
  'inazuma_eleven_api_reference_2', 'inazuma_eleven_api_reference_5', 'inazuma_eleven_api_reference_8',
  'inazuma_eleven_api_reference_12', 'inazuma_eleven_api_reference_4050',
];

const starterLineup = [
  'inazuma_eleven_api_reference_1',
  'inazuma_eleven_api_reference_3', 'inazuma_eleven_api_reference_4', 'inazuma_eleven_api_reference_6', 'inazuma_eleven_api_reference_11',
  'inazuma_eleven_api_reference_7', 'inazuma_eleven_api_reference_9', 'inazuma_eleven_api_reference_10', 'inazuma_eleven_api_reference_13',
  'inazuma_eleven_api_reference_2', 'inazuma_eleven_api_reference_5',
];

const royalAcademyLineup = [
  'inazuma_eleven_api_reference_18',
  'inazuma_eleven_api_reference_19', 'inazuma_eleven_api_reference_20', 'inazuma_eleven_api_reference_22', 'inazuma_eleven_api_reference_2425',
  'inazuma_eleven_api_reference_21', 'inazuma_eleven_api_reference_23', 'inazuma_eleven_api_reference_24',
  'inazuma_eleven_api_reference_26', 'inazuma_eleven_api_reference_28', 'inazuma_eleven_api_reference_30',
];

const teamBlueprints = teamsData.teams as unknown as Team[];
export const teams: Team[] = [
  { ...teamBlueprints[0], lineup: starterLineup },
  { ...teamBlueprints[1], name: 'Royal Academy', lineup: royalAcademyLineup },
];
export const tokens = tokensData.tokens;
export const recruitmentPool = poolsData.entries;
export const teamImageByName = new Map(
  externalTeams.teams.map((team) => [team.name.toLocaleLowerCase(), team.image_url ?? '']),
);

export const playerById = new Map(players.map((player) => [player.id, player]));
export const techniqueById = new Map(techniques.map((technique) => [technique.id, technique]));
export const formationById = new Map(formations.map((formation) => [formation.id, formation]));

export const elementLabels = {
  FIRE: 'Fuego',
  WIND: 'Viento',
  FOREST: 'Bosque',
  MOUNTAIN: 'Montaña',
} as const;

export const elementGlyphs = {
  FIRE: '▲',
  WIND: '◆',
  FOREST: '●',
  MOUNTAIN: '■',
} as const;
